/** Public route that redirects to dashboard if the user is already authenticated */

// React
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// Constants
import { DASHBOARD_ROUTE } from './constants';

const PublicRoute = ({ authenticated, Component, ...rest }) => (
  <Route
    {...rest}
    render={() => (!localStorage.getItem('token') || !authenticated ? Component : <Redirect to={DASHBOARD_ROUTE} />)}
  />
);

PublicRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  Component: PropTypes.any.isRequired
};

export default PublicRoute;
